<template>
    <div class="content-widget iframe-widget">
        <iframe
            title="iframe-widget"
            class="iframe-content"
            frameBorder="0"
            :class="{
                'solen-content': widgetId === 'sunshine',
                'has-funnel': hasFunnel
            }"
            :src="url"
        />
        <FunnelFooter v-if="hasFunnel"/>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import { mapGetters } from 'vuex';

    import FunnelFooter from '@/components/funnel/FunnelFooter.vue';

    export default {
        name: 'IframeWidget',
        components: {
            FunnelFooter
        },
        data: () => ({
            hiddenSidebarWidgets: [
                'cityscan'
            ]
        }),
        props: [
            'widgetId',
            'url'
        ],
        computed: {
            ...mapGetters([
                'isIframe'
            ]),
            ...mapGetters('widget', [
                'funnel'
            ]),
            hasFunnel() {
                return this.funnel && !this.isFunnel;
            },
            isFunnel() {
                return this.isIframe && document.referrer === process.env.FUNNEL_URL;
            }
        },
        mounted() {
            if (this.hiddenSidebarWidgets.includes(this.$props.widgetId)) {
                EventBus.$emit('toggleSidebar');
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/_common.scss";
    @import "@/assets/scss/main.scss";
    @import "@/assets/scss/components/_sidebar.scss";

    .iframe-content{
        width: 100%;
        height: 100%;
        &.solen-content{
            height: 95vh;
            margin-top: 55px;
        }
        &.has-funnel {
            height: calc(100% - 4%);
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/IframeWidget.vue